import { useMutation } from 'react-query';

import { copyVersion as mutationFn } from 'api/endPoints/copyVersion';

export const useMutationCopyVersion = () => {
    return useMutation<unknown, QueryError, QueryParams>({ mutationFn: (params) => mutationFn(params) });
};

interface QueryParams {
    metaDataId: number;
    contractId: number;
    projectId: number;
    versionName: string;
}
